export default {
  engagementQueueRules(state) {
    return state.engagementQueueRules;
  },
  engagementQueueRuleDetail(state) {
    return state.engagementQueueRuleDetail;
  },
  worksaceGroupIsStorm(state) {
    return state.worksaceGroupIsStorm;
  },
  engagementQueueRuleTags(state) {
    return state.engagementQueueRuleTags;
  },
  feedQueueAssignment(state) {
    return state.feedQueueAssignment;
  },
  engagementQueueRuleTagsForSelect(state) {
    return state.engagementQueueRuleTags.map((tag) => ({
      id: tag.value,
      text: tag.name,
    }));
  },
};
